module.exports = __webpack_public_path__ + "static/media/029-spaceship.e7a97fce.svg";